// extracted by mini-css-extract-plugin
export default {"icon":"SelectDropdown_icon__CvR++","select":"SelectDropdown_select__GXpfn"};